import React, { Component } from "react";
import {
    INPUT_TYPE,
    DKIcons
} from "deskera-ui-library";
import {
  COLUMN_CODE,
  TableManger,
  TABLES,
} from "../../../managers/TableManger";
import {CONSTANTS, URL_V1} from "../../../constants/Constant"
import ApiConstants from "../../../constants/ApiConstants";
import { isViewportLarge } from "../../../utility/ViewportSizeUtils";
const uploadCloudImg = "http://s3.ap-southeast-1.amazonaws.com/cdn-crm-common-env/report/thumbnail/71273/1628178064451_upload_cloud_outlined.svg";

/*
PROPS
- data
- borderStyle
- isEditing
- hash
*/

class Form extends Component {
  render() {
    return (
      <div
        style={{
          ...this.props.data.style,
          ...this.props.borderStyle,
          borderSpacing: "" + this.props.data.style.cellSpacing + "px 0px",
          maxWidth: "100%",
        }}
      >
        <form id="dk-crm-form-submission" name={this.getFormData()} onMouseOver={this.props.onMouseOverInner}>
          {this.getFormFields(this.props.data.value, this.props.data.style)}

          <input
            type="submit"
            name="dksubmit"
            id="dksubmit"
            value={this.props.data.button.value}
            style={{
              fontSize: this.props.data.button.style.buttonSize,
              backgroundColor: this.props.data.button.style.buttonBackground,
              color: this.props.data.button.style.buttonColor,
              marginTop: 15,
              marginBottom: 15,
              padding: 8,
              width: "98%",
              borderColor: this.props.data.button.style.buttonBackground,
              border: "solid",
              borderRadius: 10,
              pointerEvents: this.props.isEditing === true ? "none" : "auto",
              cursor: this.props.isEditing === true ? "none" : "pointer",
              fontWeight: 600,
            }}
          />

        </form>
      </div>
    );
  }

  getFormData() {
    let defaultData = {};
    defaultData[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING)] = this.props.data.selectedSegmentData && this.props.data.selectedSegmentData.length > 0 ? this.getDefaultValue(this.props.data.selectedSegmentData, CONSTANTS.SEGMENT) : [1];
    defaultData[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS)] = [1];
    defaultData[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.TYPE)] = [1];
    defaultData[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID)] = this.getDefaultValue(this.props.data.selectedSegmentData, CONSTANTS.PIPELINE);
    defaultData[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID)] = this.getDefaultValue(this.props.data.selectedSegmentData, CONSTANTS.STAGE);
    let obj = {
      baseURL: ApiConstants.URL.BASE + URL_V1,
      defaultData: defaultData,
      hash: this.props.hash,
      thankYouMsg: this.props.data.thankYouMsg,
      redirectURL: this.props.data.redirectURL
    };
    return JSON.stringify(obj);
  }

  getFormFields(items, style) {
    let arr = [];
    items.forEach((item, index) => {
      arr.push(this.getFieldContainer(index, item, style));
    });
    return arr;
  }

  getFieldContainer(index, data, style) {
    return (
      <div
        key={data.key}
        style={{
          display: "block",
          padding: style.fieldSpacing,
          pointerEvents: this.props.isEditing ? "none" : "auto",
        }}
      >
        <div
          key={index}
          style={{
            width: "100%",
            display: "block",
            textAlign: "left",
            marginBottom: 5,
            fontSize: style.labelSize,
            color: style.labelColor,
            float: "left",
          }}
        >
          {data.name} {data.required ? " *" : ""}
        </div>
        {this.addInputFields(data, style)}
      </div>
    );
  }

  addInputFields(data, style) {
    switch(data.type) {
      case INPUT_TYPE.SELECT:
        return this.getSelectField(data, style)
      case INPUT_TYPE.MULTI_SELECT:
        return this.getMultiSelectField(data, style)
        case 'file':
            return this.getFileUploadField(data, style)
      default:
        return this.getInputField(data, style)
    }
  }

  getInputField(data, style) {
    return (
      <input
        style={{
          WebkitAppearance: "none",
          MozAppearance: "none",
          appearance: "none",
          width: "100%",
          border: "solid",
          borderWidth: 2,
          borderRadius: style.fieldRadius,
          borderColor: style.fieldBorder,
          backgroundColor: style.fieldBackground,
          boxSizing: "border-box",
          paddingTop: 8,
          paddingBottom: 8,
          paddingLeft: 10,
          paddingRight: 10,
          outline: "none",
          boxShadow: "none !important",
          backgroundImage: "none",
        }}
        key={data.key}
        type={data.type}
        name={data.key}
        id={data.key}
        required={data.required}
      />
    );
  }

  getSelectField(data, style) {
    return (
      <select
        style={{
          WebkitAppearance: "none",
          MozAppearance: "none",
          appearance: "none",
          width: "100%",
          border: "solid",
          borderWidth: 2,
          borderRadius: style.fieldRadius,
          borderColor: style.fieldBorder,
          backgroundColor: style.fieldBackground,
          boxSizing: "border-box",
          paddingTop: 8,
          paddingBottom: 8,
          paddingLeft: 10,
          paddingRight: 10,
          outline: "none",
          boxShadow: "none !important",
          backgroundImage: "none",
        }}
        key={data.key}
        name={data.key}
        id={data.key}
        required={data.required}
      >
        <option hidden></option>
        {(data.options || []).map((item, index) => (
          <option key={index} value={item.id}>{item.name}</option>
        ))}
      </select>
    );
  }

  getMultiSelectField(data, style) {
    return (
      <div>
      <select
        multiple
        style={{
          WebkitAppearance: "none",
          MozAppearance: "none",
          appearance: "none",
          width: "100%",
          border: "solid",
          borderWidth: 2,
          borderRadius: style.fieldRadius,
          borderColor: style.fieldBorder,
          backgroundColor: style.fieldBackground,
          boxSizing: "border-box",
          paddingTop: 8,
          paddingBottom: 8,
          paddingLeft: 10,
          paddingRight: 10,
          outline: "none",
          boxShadow: "none !important",
          backgroundImage: "none",
        }}
        key={data.key}
        name={data.key}
        id={data.key}
        required={data.required}
      >
        {(data.options || []).map((item, index) => (
          <option key={index} value={item.id}>{item.name}</option>
        ))}
      </select>
      <div style={{color: 'gray', textAlign:'left', marginLeft:'4px', marginTop:"5px"}}>(Press Shift to select multiple options)</div>
      </div>
    );
  }
  getFileUploadField(data, style){
    return (
        <div>
            <div
                id="file-upload"
                name={data.key}
                style={{
                    cursor: "pointer",
                    borderRadius: '6px',
                    marginTop: '20px',
                    position:'relative'
                }}
            >
                {/* <img style={{ height: "60px", display: "none" }} src={uploadCloudImg} alt="Upload Cloud"/> */}

                <div style={{
                    display:'flex',
                    alignItems: "center",
                    textAlign: "left",
                    width: "100%",
                    position: "relative",
                    zIndex: 999
                }}>


                    <button id="choose-file-button" type="button" style={{
                        borderRadius: '8px',
                        height: '30px',
                        width: `${isViewportLarge() ? '130px': '100%'}`,
                        backgroundColor: "#fff",
                        fontWeight: "600",
                        border: "1px solid #dcdcdc",
                        fontSize: "13px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "5px",
                        cursor: "pointer"
                    }}>
                        <img src={DKIcons.ic_document} style={{height: "16px"}}/>
                        <span style={{marginLeft: "5px"}}>{isViewportLarge() ? 'Choose a file' : 'Attach (.pdf, .docx or .doc)'}</span>
                    </button>
                    <span className={'display-only-web'} style={{
                        overflowWrap: "break-word",
                        whiteSpace: "pre-wrap",
                        fontSize: "13px",
                        textAlign: "left"
                    }}>Choose .pdf, .docx or .doc</span>
                </div>
                <input
                    type="File"
                    name={data.key}
                    id={data.key}
                    required={data.required}
                    style={{
                      position: 'absolute',
                      top: '5px',
                      left: '15px',
                      opacity: 0,
                      zIndex: -999
                    }}
                    multiple={true}
                    accept=".pdf,.doc,.docx"
                />
            </div>
            <div id="file-details" name={`file-details_${data.key}`} style={{ marginTop: "30px", display: "none" }}>
                <div style={{ marginTop: "-20px", float: "left" }}>File Details</div>
                <div id={`file-list_${data.key}`} name="file-list-name"></div>
                <div id={`single-file_${data.key}`} style={{
                    background: '#f4f4f6',
                    borderRadius: '6px',
                    border: '1px solid #d2d1d1',
                    marginTop: '20px'
                }}>
                    <div style={{ display: "flex", padding: "10px" }}>
                        <span id="file-name"></span>
                        <span id="file-size" style={{ marginLeft: "auto", color: "#1664d7" }}></span>
                    </div>
                </div>
            </div>
        </div>
      );
    }
  getDefaultValue(dataSource, module) {
    if (dataSource && dataSource.length > 0) {
      switch (module) {
        case CONSTANTS.SEGMENT:
          dataSource = dataSource.filter(x => x.type === CONSTANTS.SEGMENT);
          dataSource = dataSource.map((value) => {
            return value.id;
          });
          return dataSource.length > 0 ? dataSource : [1];
        case CONSTANTS.PIPELINE:
          dataSource = dataSource.filter(x => x.type === CONSTANTS.PIPELINE);
          dataSource = dataSource.map((value) => {
            return value.id;
          });
          return dataSource;
        case CONSTANTS.STAGE:
          dataSource = dataSource.filter(x => x.type === CONSTANTS.PIPELINE);
          dataSource = dataSource.map((value) => {
            let stageData = value[COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S];
            if (stageData && stageData[0]) {
              return stageData[0]
            }
          });
          return dataSource;
        default:
          return []
      }
    }
  }
}

export default Form;
